import LogRocket from 'logrocket'

import type { ApolloClient as ApolloOfflineClient } from '@wora/apollo-offline'
import type ApolloClient from 'apollo-client'

const TTL = 1000 * 60 * 60 * 24 * 7 // 1 week

export function removeExpiredStoredMutations(client: ApolloClient<any>) {
  // useApolloClient returns normal ApolloClient, but it'll actually be ApolloOfflineClient
  const _client = client as ApolloOfflineClient
  const expiredIds = _client
    .getStoreOffline()
    .getListMutation()
    .filter((mutation) => {
      const expired = mutation.fetchTime < Date.now() - TTL

      if (expired) {
        LogRocket.captureMessage('Removing expired mutations')
        LogRocket.info({
          ...mutation,
          request: {
            variables: mutation?.request?.payload?.variables
          }
        })
      }

      return expired
    })
    .map((mutation) => mutation.id)

  expiredIds.forEach((mutationId) => {
    _client.getStoreOffline().remove(mutationId)
  })
}
